import React, { useContext, useState } from 'react'
import { ReactComponent as LogoSvg } from '../../assets/svgs/logos/Logo.svg'
import { Icon } from '../Icon'
import { useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '../../context/AuthContext'
import '../../App.css'
import { getSchool } from '../../api/admin/settings'
// import { toast } from 'react-toastify'
import { SchoolDetails, SchoolDetailsResponse } from '../../utils/types'
import { useQuery } from 'react-query'
import { SidebarContext } from '../../context/SidebarContext'
import { returnRole, returnSubRole } from '../../routes/paths'

interface MenuItem {
  name: string
  logo: string
  path: string
}

interface sidebarItem {
  name: string
  logo: string
  path: string
  hasChild: boolean
  child?: MenuItem[]
}

const UISIdeBar = () => {
  const useRole = localStorage.getItem('userRole')
  const navigate = useNavigate()
  const { user } = useAuth()
  const { setView, setViewBool } = useContext(SidebarContext)
  const location = useLocation()
  const [isSubMenuOpen, setIsSubMenuOpen] = useState<boolean>(false)
  const [isChildPath, setIsChildPath] = useState<string>(location.pathname)
  const [isPath, setIsPath] = useState<string>(location.pathname)

  const getSchoolData = async (): Promise<SchoolDetails> => {
    const response = (await getSchool()) as SchoolDetailsResponse
    return response?.data
  }
  const pathsToSetViewBoolFalse = [
    '/home/lead/incidents',
    '/home/lead/whistleblowing',
    '/home/incidents',
    '/home/whistleblowing',
    '/home/policyManager',
    '/home/training',
    '/home/resources',
  ]
  const school = useQuery('school', getSchoolData)

  return (
    <div className={'w-72 bg-gray1 h-screen flex-col align-top '}>
      {useRole != 'super' && (
        <div className="flex gap-4 flex-1 pb-7 pt-[55px] px-20 ">
          {school?.data?.logo == '' && <LogoSvg width={130} height={36} />}
          {school?.data?.logo == null && <LogoSvg width={130} height={36} />}
          {school?.data?.logo == 'https:www.logo.com/logo' && (
            <LogoSvg width={130} height={36} />
          )}
          {school?.data?.logo == 'www.logo.com/logo' && (
            <LogoSvg width={130} height={36} />
          )}
          {school?.data?.logo !== 'www.logo.com/logo' &&
            school?.data?.logo !== '' &&
            school?.data?.logo !== null &&
            school?.data?.logo !== 'https:www.logo.com/logo' && (
              <img src={school?.data?.logoUrl} width={100} height={30} />
            )}
        </div>
      )}

      {useRole == 'super' && (
        <div className="flex gap-4 flex-1 pb-7 pt-[55px] px-20 ">
          <LogoSvg width={130} height={36} />
        </div>
      )}

      <div
        className={
          'flex-col align-top px-4  h-[64vh] pt-[10px] custom-scrollbar  overflow-scroll'
        }
      >
        {returnRole(user?.role?.role || useRole)?.map(
          (i: sidebarItem, index: number) => (
            <>
              <div
                key={index}
                onClick={() => {
                  navigate(i.path)
                  setIsPath(i.path)
                  if (i.path === '/home/scr') {
                    setView('centeral-records')
                  }

                  if (pathsToSetViewBoolFalse.includes(i.path)) {
                    setViewBool(false)
                  }
                  setIsChildPath(i.path)
                  setIsSubMenuOpen((prevState) =>
                    i.hasChild && i.path !== location.pathname
                      ? true
                      : !prevState
                  )
                }}
                className={`flex items-center pl-5 h-12 w-64 ${
                  i.path === isPath ? 'bg-gray2' : ''
                } my-2 rounded-full cursor-pointer`}
              >
                <div className="flex items-center">
                  <div className="mr-2 w-3">
                    {i?.hasChild && (
                      <Icon
                        name={
                          isSubMenuOpen && i?.path == isPath
                            ? 'IconChevronDown'
                            : 'IconChevronRight'
                        }
                        strokeWidth={1}
                        stroke={'#67A5B9'}
                        width={isSubMenuOpen && i?.path == isPath ? 16 : 10}
                        height={isSubMenuOpen && i?.path == isPath ? 16 : 10}
                      />
                    )}
                  </div>

                  <Icon
                    name={i.logo}
                    strokeWidth={1}
                    stroke={i?.path == isPath ? '#02698C' : '#67A5B9'}
                  />
                  <p
                    className={`ml-3 text-sm  ${
                      isPath === i.path ? 'text-text2' : 'text-text3'
                    } 
                    ${isPath === i.path ? 'font-semibold' : 'font-medium'}
                    `}
                  >
                    {' '}
                    {i.name}
                  </p>
                </div>
              </div>
              {isSubMenuOpen &&
                i?.hasChild &&
                i?.path == isPath &&
                i?.child?.map((childItem: MenuItem, index: number) => {
                  return (
                    <>
                      <div
                        key={index}
                        onClick={() => {
                          navigate(childItem?.path)
                          setIsChildPath(childItem?.path)
                        }}
                        className="p-4 ml-[58px] cursor-pointer"
                      >
                        <p
                          className={`text-xs font-medium hover:text-text2 ${childItem?.path == isChildPath ? 'text-text2' : 'text-text3'}`}
                        >
                          {childItem?.name}
                        </p>
                      </div>
                    </>
                  )
                })}
            </>
          )
        )}
      </div>
      {/* Sidebar Items-bottom branding */}
      <div className={'flex-col align-top px-4'}>
        {returnSubRole(user?.role?.role || useRole)?.map(
          (i: MenuItem, index: number) => (
            <>
              <div
                key={index}
                onClick={() => {
                  navigate(i.path)
                  setIsPath(i?.path)
                }}
                className={`
              flex items-center pl-10 h-12 w-64
               ${i.path === isPath ? 'bg-gray2' : ''}
            my-2 rounded-full cursor-pointer`}
              >
                <div className="flex items-center">
                  <Icon name={i.logo} strokeWidth={1} stroke={'#02698C'} />
                  <p
                    className={`ml-3 text-sm font-medium  ${
                      isPath === i.path ? 'text-text2' : 'text-text3'
                    } `}
                  >
                    {' '}
                    {i.name}
                  </p>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </div>
  )
}

export default UISIdeBar
